module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"year":"Year","month":"Month"},"zh":{"year":"年","month":"月"}}')
  delete Component.options._Ctor
}
